import { render, staticRenderFns } from "./MajoritiesTable.vue?vue&type=template&id=bcb862c0&"
import script from "./MajoritiesTable.vue?vue&type=script&lang=js&"
export * from "./MajoritiesTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports